import { makeImmutable } from "../../core";
export class FreeDeliveryInfo {
    constructor(params) {
        this.minPriceForFreeDelivery = params.minPriceForFreeDelivery;
        makeImmutable(this);
    }
}
